import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { EXPLORE_BTNS_MINI_STORE } from "../../../utilities/constants";
import { MiniStoreThemeContext } from "../../../MiniStoreContexts/MiniStoreThemeContext";

const ExploreBtns = () => {
  const navigate = useNavigate();
  const { theme } = useContext(MiniStoreThemeContext);

  const handleButtonClick = (path) => {
    // Navigate to the correct route
    navigate(`/storefront/home/${path}`);
  };

  return (
    <div className="container-fluid d-flex flex-column justify-content-center align-items-center">
      <StyledLine theme={theme} />
      <ExploreHeading>Explore</ExploreHeading>
      <ButtonsWrapper>
        {EXPLORE_BTNS_MINI_STORE.map((btn, index) => (
          <StyledButton
            theme={theme}
            key={index}
            onClick={() => handleButtonClick(btn.path)}
          >
            {btn.title}
          </StyledButton>
        ))}
      </ButtonsWrapper>
    </div>
  );
};

export default ExploreBtns;

// Styled Components
const ExploreHeading = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 38px;
  font-family: Outfit, sans-serif;
  font-weight: 500;
  padding: 1.5rem;
`;
const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
  max-width: 900px;
  justify-content: center;
  @media (max-width: 425px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const StyledButton = styled.button`
  background-color: ${({ theme }) => theme.primaryColor.primary};
  color: ${({ theme }) => theme.textColor.primary};
  padding: 12px 20px;
  border: none;
  border-radius: 0.15rem;
  font-size: 18px;
  font-weight: 500;
  font-family: "Outfit", sans-serif;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  &:hover {
    opacity: 0.9;
  }
`;
const StyledLine = styled.div`
  width: 223px;
  height: 5px;
  background-color: ${({ theme }) => theme.primaryColor.primary};
  box-shadow: ${({ theme }) => theme.boxShadow?.secondary};
  border-radius: 0.15rem;
`;
